export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-6 text-center">关于91影视看片app</h2>

          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              91影视看片app是一款专注于移动端高清影视在线观看的免费应用，自上线以来始终秉持"开放、免费、高清、流畅"的产品理念，致力于为广大影视爱好者提供一站式的观影解决方案。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              我们聚合了海量正版及公共领域影视资源，覆盖电影、电视剧、综艺、动漫、纪录片等多维度内容类别。通过自研的视频编解码与CDN加速技术，即使在低速网络环境下，也能为用户提供流畅的高清观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              91影视看片app支持安卓与苹果iOS双平台，兼容主流手机型号与系统版本。团队持续迭代更新，每个版本都针对性能、画质和用户体验进行优化，确保用户始终使用到最新、最稳定的版本。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              目前，91影视看片app已累计服务超过千万用户，日均活跃用户数百万。无论是通勤路上的碎片时间，还是周末宅家的休闲时光，91影视看片app都是您值得信赖的免费观影伴侣。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}